import clsx from 'clsx';
import { motion, MotionProps } from 'framer-motion';
import { useSwitchToggle } from '../hooks/useSwitchToggle';
import { Icon, IconName } from './Icon';

interface SwitchToggleProps extends ReturnType<typeof useSwitchToggle> {
  onIconName?: IconName;
  offIconName?: IconName;
  buttonMotionProps?: MotionProps;
}

export function SwitchToggle({
  isOn,
  toggleSwitch,
  onIconName,
  offIconName,
  isDisabled,
  buttonMotionProps,
}: SwitchToggleProps) {
  return (
    <motion.button
      onClick={toggleSwitch}
      disabled={isDisabled}
      type="button"
      role="switch"
      aria-checked={isOn}
      aria-label={isOn ? 'On' : 'Off'}
      className={clsx(
        'flex items-center rounded-full w-[45px] h-6 border group cursor-pointer disabled:cursor-not-allowed disabled:opacity-50',
        isOn
          ? 'justify-end bg-palette-600/40 border-palette-600/20'
          : 'justify-start bg-darkMode-gray-medium/30 border-darkMode-gray-dark/50'
      )}
      {...buttonMotionProps}
    >
      <motion.div
        initial={false}
        layout="position"
        transition={{ type: 'spring', visualDuration: 0.2, bounce: 0.2 }}
        className={clsx(
          'rounded-full w-1/2 h-full shadow-md grid place-content-center',
          isOn ? 'bg-palette-600/90' : 'bg-darkMode-gray-light/[0.15]'
        )}
      >
        {isOn && onIconName && <Icon icon={onIconName} className="text-palette-200/90 !h-3 !w-3" />}
        {!isOn && offIconName && <Icon icon={offIconName} className="text-darkMode-gray-light/90 !h-3 !w-3" />}
      </motion.div>
    </motion.button>
  );
}
